import React from 'react';
import { ContentArea } from '@styles/common';
import { GridCellParams, GridColTypeDef, GridColumns } from '@material-ui/data-grid';
import { useAuth } from '@domain/auth/auth.hook';
import { CancelToken } from 'axios';
import { IconButton } from '@material-ui/core';
import { Link } from '@components/link';
import { Visibility } from '@material-ui/icons';
import { formatColWithDate } from '@components/datagrid/custom.datagrid.props';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { useGame } from '@domain/game.selection/game.selection.hook';
import { SeasonsTable } from '@screens/season/seasons.styles';

const baseColProps: GridColTypeDef = {
  align: 'center',
  headerAlign: 'center',
};

const columns: GridColumns = [
  { field: 'id', headerName: 'Id', type: 'string', width: 100 },
  { field: 'scheduledStartDate', headerName: 'Scheduled Start', ...formatColWithDate, width: 179 },
  { field: 'scheduleEndDate', headerName: 'Scheduled End', ...formatColWithDate, width: 196 },
  { field: 'startDate', headerName: 'Start', ...formatColWithDate },
  { field: 'endDate', headerName: 'End', ...formatColWithDate },
  { field: 'theme', headerName: 'Theme', type: 'string', width: 161 },
  { field: 'minLevel', headerName: 'Level', width: 120 },
  { field: 'pot', headerName: 'Pot' },
  {
    field: 'seasonId',
    headerName: ' ',
    width: 50,
    renderCell: (params: GridCellParams) => (
      <IconButton color='primary' size='small' component={Link} to={`/seasons/${params.value}`}>
        <Visibility />
      </IconButton>
    ),
    ...baseColProps,
  },
];

interface Season {
  id: number;
}

function createData(season: Season) {
  return { seasonId: season.id, ...season };
}

const Seasons = () => {
  const game = useGame();
  const { authorizedServices } = useAuth();

  async function runSearch(data: any, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get<Season[]>('/admin/seasons/list', { params: { ...data, page }, cancelToken });
  }

  const { responseData, pageCount, loading, error } = usePagedData(null, runSearch, { placeholderData: noopArray });

  const rows = responseData?.map(createData) || [];

  return (
    <ContentArea>
      <SeasonsTable>
        <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
      </SeasonsTable>
    </ContentArea>
  );
};

export default Seasons;
